import { css } from '@emotion/react';

const makeFormElementStyles = ({ theme, isVisible }) => {
  return {
    component: css({
      display: isVisible ? 'block' : 'none',
    }),
    maxWidthWrapper: css({
      [theme.breakpoints.up('md')]: {
        maxWidth: theme.breakpoints.values.md,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    }),
  };
};

export default makeFormElementStyles;
